module.exports = __webpack_public_path__ + "static/media/left-arrow.39f939da.svg";